<template>
  <div @click="checkValue">
    <div>
      <div style="display: flex; align-items: end">
        <div class="yesnoQuestion">
          <input
            type="checkbox"
            class="checkbox-div"
            :checked="showTimeValue"
            v-model="showTimeValue"
            @click="showTimeValue != showTimeValue"
          />
          <p style="margin-right: 12px">Farmer Life Time Value</p>
        </div>

        <!-- <question-tab heading="Does the farmer have any Land?" /> -->
      </div>
      <div style="margin-left: 28px; margin-top: 0px" v-if="showTimeValue">
        <div class="mainDiv">
          <div class="inputDiv" style="">
            <div class="rupeeDiv">
              <img src="../../../../assets/rupee.svg" alt="" />
            </div>
            <div class="inputBox">
              <input
                class="input"
                v-model="farmerLongTime.min"
                placeholder="Min. Value"
              />
            </div>
          </div>

          <div class="inputDiv">
            <div class="rupeeDiv">
              <img src="../../../../assets/rupee.svg" alt="" />
            </div>
            <div class="inputBox">
              <input
                class="input"
                v-model="farmerLongTime.max"
                type="text"
                placeholder="Max. Value"
              />
            </div>
          </div>
        </div>
        <!-- <div v-if="showErrorMessage" class="error-message">
          Note: Min. value cannot be more than max. value
        </div> -->
      </div>
    </div>
    <div>
      <div style="display: flex; align-items: end">
        <div class="yesnoQuestion">
          <input
            type="checkbox"
            :value="true"
            class="checkbox-div"
            v-model="showProfile"
          />
          <p style="margin-right: 12px">Profile Score (1 - 10)</p>
        </div>

        <!-- <question-tab heading="Does the farmer have any Land?" /> -->
      </div>
      <div style="margin-left: 28px; margin-top: 0px" v-if="showProfile">
        <div class="mainDiv">
          <div class="inputDiv" style="">
            <div class="rupeeDiv">
              <img src="../../../../assets/rupee.svg" alt="" />
            </div>
            <div class="inputBox">
              <input
                class="input"
                v-model="profileScore.min"
                placeholder="Min. Value"
                type="number"
                required
              />
            </div>
          </div>

          <div class="inputDiv">
            <div class="rupeeDiv">
              <img src="../../../../assets/rupee.svg" alt="" />
            </div>
            <div class="inputBox">
              <input
                class="input"
                v-model="profileScore.max"
                type="text"
                placeholder="Max. Value"
                required
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div style="display: flex; align-items: end">
        <div class="yesnoQuestion">
          <input
            type="checkbox"
            :value="true"
            class="checkbox-div"
            v-model="showProgression"
          />
          <p style="margin-right: 12px">Progression/Risk Level</p>
        </div>

        <!-- <question-tab heading="Does the farmer have any Land?" /> -->
      </div>
      <div style="margin-left: 28px; margin-top: 0px" v-if="showProgression">
        <div class="mainDiv">
          <div style="display: flex; align-items: center">
            <input
              type="checkbox"
              class="checkbox-div"
              v-model="progression.high"
            />
            <p style="margin-right: 2px; transform: translateY(10px)">High</p>
          </div>
          <div style="display: flex; align-items: center">
            <input
              type="checkbox"
              :value="true"
              class="checkbox-div"
              v-model="progression.med"
            />
            <p style="margin-right: 2px; transform: translateY(10px)">Mid</p>
          </div>
          <div style="display: flex; align-items: center">
            <input
              type="checkbox"
              :value="true"
              class="checkbox-div"
              v-model="progression.low"
            />
            <p style="margin-right: 2px; transform: translateY(10px)">Low</p>
          </div>
        </div>
      </div>
      <div v-if="showProfileErrorMessage" class="error-message">
        Note: Min. value cannot be more than max. value
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "engagementTab",
  data() {
    return {
      minValue: "",
      maxValue: "",
      minPlaceholderText: "Minimum value",
      maxPlaceholderText: "Maximum value",
      showProfileErrorMessage: false,
      showErrorMessage: false,
      showTimeValue: false,
      showProfile: false,
      showProgression: false,
      farmerLongTime: {
        click: this.showTimeValue,
        min: null,
        max: null,
      },
      profileScore: {
        click: this.showProfile,
        min: null,
        max: null,
      },
      progression: {
        click: this.showProgression,
        low: null,
        med: null,
        high: null,
      },
    };
  },
  computed: {},
  watch: {
    farmerLongTime: {
      handler(newValues) {
        this.validateMinMax(newValues.min, newValues.max);
        console.log("farmerLongTime", this.farmerLongTime);
      },
      deep: true,
    },
    profileScore: {
      handler(newValues) {
        this.validateMinMax(newValues.min, newValues.max);
        console.log("profileScore", this.profileScore);
      },
      deep: true,
    },
    showTimeValue: function (newValues) {
      console.log("showTimeValue", this.showTimeValue, this.farmerLongTime);
      if (this.showTimeValue) {
        this.farmerLongTime.click = this.showTimeValue;
      } else {
        this.farmerLongTime.click = this.showTimeValue;
        this.farmerLongTime.min = null;
        this.farmerLongTime.max = null;
      }
    },
    showProfile: function (newValues) {
      console.log("showProfile", this.showProfile, this.profileScore);
      if (this.showProfile) {
        this.profileScore.click = this.showProfile;
      } else {
        this.profileScore.click = this.showProfile;
        this.profileScore.min = null;
        this.profileScore.max = null;
      }
    },
    showProgression: function (newValues) {
      console.log("progression", this.showProgression);
      if (this.showProgression) {
        this.progression.click = this.showProgression;
      } else {
        this.progression.click = this.showProgression;
        this.progression.med = null;
        this.progression.low = null;
         this.progression.high = null;
      }
     
    },
  },

  methods: {
    validateMinMax(min, max) {
      if (min !== null && max !== null && parseInt(min) > parseInt(max)) {
        this.showErrorMessage = true;
      } else {
        this.showErrorMessage = false;
      }
    },

    checkValue() {
      console.log(this.farmerLongTime);

      this.farmerLongTime.click = this.showTimeValue;
      this.$store.dispatch("crmFilters/setEngagement", {
       farmerLongTime: this.farmerLongTime,
       profileScore: this.profileScore,
       progression: this.progression,
    });
    },
  },
};
</script>
<style lang="scss" scoped>
.currency-prefix {
  position: absolute;
  padding: 0.5rem;
  pointer-events: none;
}
.inputDiv {
  background: #ffffff;
  display: flex;
  border: 1px solid #efefef;
  border-radius: 4px;
  width: 160px;
  height: 43px;
}
.error-message {
  color: red;
  margin-top: 0.5rem;
}
.rupeeDiv {
  width: 16%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.inputBox {
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.input {
  width: 80%;
  padding: 3px;
}
.mainDiv {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 336px;
  height: 43px;
}
.question-tab {
  height: 51px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  gap: 16px;
  margin-left: 2px;
  width: 100%;
  p {
    margin: 0;
  }
}
.yesnoQuestion {
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  margin-left: 28px;
  width: 100%;
  p {
    margin: 0;
  }
}
.checkbox-div {
  display: flex;
  align-items: center;
  width: 40%;
  gap: 2px;
  margin-right: 8px;
  .check {
    display: flex;
    align-items: center;
    gap: 12px;
    p {
      color: #4b4b4b;
    }
  }
}
input[type="checkbox"] {
  accent-color: #189d3b;
  height: 16px;
  width: 16px;
  border-radius: 4px;
}
.expand {
  //border-bottom: 1px solid #efefef;
  z-index: unset;
}
.noexpand {
  width: 80%;
  display: flex;
  justify-content: flex-end;

  border-bottom: 1px solid #efefef;
}
.expand .v-expansion-panels {
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  width: 100%;
  position: inherit;
  margin-bottom: 5px;
}
</style>
